import { useState } from "react";
import classNames from "classnames";
import { HiOutlineStop } from "react-icons/hi";

import ModalSmartStowStopEvents from "./modals/ModalSmartStowStopEvents";

export default function SmartStowEnableEvents({ system }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <button
                className={classNames(
                    "flex justify-center items-center gap-2 bg-white text-sm py-2 px-4 border border-sky-600 rounded",
                    "text-sky-600 hover:text-sky-950 hover:border-sky-950"
                )}
                onClick={() => setIsModalOpen(true)}
            >
                <HiOutlineStop fontSize={24} />
                Stop Stow Events
            </button>

            <ModalSmartStowStopEvents
                system={system}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </>
    );
}
